export default __webpack_public_path__ + "static/media/CHANGELOG.810f6215.md";